import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { IrmaoTable } from "../../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";
export const Visitas = ({ data }) => {
  const columnsVisitas = [
    {
      Header: "Nome",
      accessor: "nomeVisitante",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Vínculo",
      accessor: "vinculo",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props.value}</Text>;
      },
    },
    {
      Header: "Data da última visita",
      accessor: "ultimaVisita",
      Cell: (props) => {
        const custom_date = new Date(props?.value).toLocaleDateString("pt-BR");
        return <span>{props.value ? custom_date : ""}</span>;
      },
    },
    {
      Header: "No mês",
      accessor: "ultimoMes",
      Cell: (props) => {
        return (
          <Flex w="50%" justifyContent={"center"}>
            <span>{props?.value}</span>
          </Flex>
        );
      },
    },
    {
      Header: "Últimos 3 meses",
      accessor: "ultimoTresMeses",
      Cell: (props) => {
        return (
          <Flex w="50%" justifyContent={"center"}>
            <span>{props?.value}</span>
          </Flex>
        );
      },
    },
    {
      Header: "Últimos 6 meses",
      accessor: "ultimoSeisMeses",
      Cell: (props) => {
        return (
          <Flex w="50%" justifyContent={"center"}>
            <span>{props?.value}</span>
          </Flex>
        );
      },
    },
  ];

  return data && data.length > 0 ? (
    <Box className="break-page">
      <Flex>
        <Group bgColor="#fff" title="Visitas" py="12px" mtDivider="5px">
          <IrmaoTable
            disableHeaderOptions={true}
            columns={columnsVisitas}
            data={data}
            filiacoes={data}
            entidade="visitas"
            visitasImprimir={true}
            isPrint={true}
          />
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Visitas"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
